import {FiBarChart2} from "react-icons/fi";
import {Link, useLocation} from "react-router";

import {Button} from "@/components/button/Button.tsx";
import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {Last30Days} from "@/components/datePicker/subComponents/DatePickerShortcutList/DatePickerShortcutList.utils.ts";
import {Icon} from "@/components/icon/Icon.tsx";
import {METRICS_EXPLORER} from "@/lib/featureFlags.ts";
import {buildExplorerLink} from "@/pages/metricsExplorer/checkPreset.ts";

interface ExploreMetricsButtonProps {
  checkId: number;
  checkType: string;
}

/**
 * Opens the explorer on this check, carrying over the date range the user is looking at, and
 * tells it where to send the back arrow.
 * Transaction checks arrive with their per-step breakdown already on the chart.
 */
export const ExploreMetricsButton = ({checkId, checkType}: ExploreMetricsButtonProps) => {
  const {userHasFeature} = useCurrentUserContext();
  const location = useLocation();

  if (!userHasFeature(METRICS_EXPLORER)) {
    return null;
  }

  return (
    <Button
      variant="secondary"
      size="large"
      as={Link}
      // Must match the analysis page's own default, so an untouched picker still carries over.
      to={buildExplorerLink(checkId, checkType, location.search, Last30Days.value)}
      state={{from: location}}
    >
      <Icon icon={FiBarChart2} /> Explore Metrics
    </Button>
  );
};
